export enum PlotType {
    ParameterResponseCrossPlot = "parameterResponseCrossPlot",
}
